import { writable, type Writable } from 'svelte/store';
import type { DropZone } from './zone';

function createZones() {
	const { subscribe, update } = writable<Array<DropZone>>([]);

    const add = ( dz:DropZone ) => update( s =>  [ ...s, dz ] );
    const remove = ( dz:DropZone ) => update( s => s.filter( i => i != dz ) );


	return {
		subscribe,
		add,
        remove,
	};
}

export const zones = createZones();
